import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Image from "../../../components/Images/Image";
import InputField from "../../../components/formControl/input/InputField";
import { getAllProductList } from "../../../redux/actions/product.action";
import { formatProductPriceLabel } from "../../../utils/productPrice";

const CollectionAddProductDialog = (props) => {
  const dispatch = useDispatch();
  const [allProductDataList, setAllProductDataList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(props.initialSelected || []);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(
      getAllProductList({
        order: "ASC",
        statusText: "PUBLISHED",
        limit: 9999,
        offset: 0,
        search: "",
      })
    ).then((response) => {
      if (response?.data?.data) {
        const selectedIds = new Set((props.initialSelected || []).map((p) => p.productId));
        const data = response.data.data.map((item) => ({
          ...item,
          isChecked: selectedIds.has(item.productId),
        }));
        setAllProductDataList(data);
        setSelectedProduct(props.initialSelected || []);
      }
    });
  }, [dispatch, props.initialSelected]);

  const filteredProducts = allProductDataList.filter((item) => {
    if (!search.trim()) return true;
    const term = search.trim().toLowerCase();
    return (item.title || "").toLowerCase().includes(term);
  });

  const onCheckProduct = (e, productId) => {
    if (e.target.checked) {
      const product = allProductDataList.find((item) => item.productId === productId);
      if (product && !selectedProduct.some((p) => p.productId === productId)) {
        setSelectedProduct([...selectedProduct, product]);
      }
      setAllProductDataList(
        allProductDataList.map((item) =>
          item.productId === productId ? { ...item, isChecked: true } : item
        )
      );
    } else {
      setSelectedProduct(selectedProduct.filter((item) => item.productId !== productId));
      setAllProductDataList(
        allProductDataList.map((item) =>
          item.productId === productId ? { ...item, isChecked: false } : item
        )
      );
    }
  };

  const onSubmit = () => {
    props.onSubmit(selectedProduct);
    props.onClose();
  };

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 font-weight-bold">Select Products</h5>
        <CloseIcon className="pointer" onClick={props.onClose} />
      </div>

      <div className="d-flex mb-3">
        <InputField
          placeholder="Search product name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <TableContainer style={{ maxHeight: 420 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Product</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Stock</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredProducts.map((row) => (
              <TableRow key={row.productId}>
                <TableCell>
                  <input
                    type="checkbox"
                    checked={!!row.isChecked}
                    onChange={(e) => onCheckProduct(e, row.productId)}
                  />
                </TableCell>
                <TableCell>
                  <div className="d-flex align-items-center">
                    <Image
                      src={row.productImages?.[0] || "/icons/upload_icon.svg"}
                      alt="product"
                      style={{ width: 48, height: 48, objectFit: "cover", marginRight: 12 }}
                    />
                    <div>{row.title}</div>
                  </div>
                </TableCell>
                <TableCell>{formatProductPriceLabel(row)}</TableCell>
                <TableCell>{row.totalStock || 0}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div className="d-flex justify-content-end mt-3">
        <button type="button" className="btn btn-light mr-2" onClick={props.onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-dark" onClick={onSubmit}>
          Add Selected ({selectedProduct.length})
        </button>
      </div>
    </div>
  );
};

export default CollectionAddProductDialog;
